/**
 * Enum for staff groups.
 * @readonly
 * @enum {Number} StaffGroupEnum
 */

const StaffGroupEnum = {
  ADMIN     : 11,
  GFP_EDITOR: 12,
  CRM_EDITOR: 13,
  OWNER     : 100,
  CASHIER   : 101,
  WAITER    : 102,
  USER      : 103,
  DELIVERY  : 104,
  KDS       : 200,

  /** @type {Array} */
  get SYSTEM() {
    return [this.ADMIN, this.GFP_EDITOR, this.CRM_EDITOR]
  },

  /** @type {Array} */
  get POS_ORDER() {
    return [this.OWNER, this.CASHIER, this.WAITER, this.ADMIN, this.GFP_EDITOR, this.CRM_EDITOR]
  }
}

export default StaffGroupEnum
